export const ERROR_CENTRIFUGE_NO_CONNECTION = `Can't connect to the server. Try to refresh the page`;
